"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const translate_1 = require("components/translate");
const ModuleTooltip = ({ t, children, title, isEnabled = true }) => {
    if (isEnabled && title) {
        return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { content: t(title), className: "_d-block", children: children }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.default = (0, translate_1.translate)()(ModuleTooltip);
